export default __webpack_public_path__ + "static/media/folder-photo.761ac190.svg";